import { getCookie } from "../helpers/getCookie";
import { participantDetail } from "./../fakeData";
import { newChatSearchData } from "./../fakeData";

let _user;

// export const baseUrl = "https://localhost:5001";
export const baseUrl = "https://chat.schoolbook.ge";

export const setCurrentUser = (user) => {
  _user = user;
};

const jsonRequest = (url, body = null, method = "POST", isPrivate = true) => {
  let fetchParms = { method: method, credentials: "include" };
  let requestHeader = {};
  if (body) {
    fetchParms.body = JSON.stringify(body);
    requestHeader["Content-Type"] = "application/json";
  }
  if (isPrivate) {
    let authToken = getCookie("authToken");
    requestHeader["authToken"] = authToken;
  }
  fetchParms.headers = requestHeader;

  return fetch(baseUrl + "/" + url, fetchParms);
};

const processJsonResponse = (response) => {
  if (response.status === 401) {
    if (_user && _user.domain) window.location.href = `http://${_user.schoolDomain}`;
    throw new Error(401);
  }
  return response.json();
};

export const fetchContactList = ({ skip = 0, search = "", type = 0 }) => {
  return jsonRequest("api/messenger/get-contacts", { skip, search, type }).then(processJsonResponse);

  // return fetch("api/messenger/get-contacts", {
  //   body: JSON.stringify({ skip, search, type }),
  //   headers: {
  //     "Content-Type": "application/json",
  //   },
  //   method: "POST",
  // }).then(processJsonResponse);
};

export const fetchConversation = ({ oponentId, isgroup, skip = 0 }) => {
  return jsonRequest(`api/messenger/get-convertation`, {
    skip,
    oponentId,
    isgroup,
  }).then(processJsonResponse);
};

export const deleteFile = (index) => {
  return jsonRequest(`api/messenger/delete-file?index=${index}`, null, "DELETE");
};

export const sendNewMessage = ({ messageToId, isGroup, messageText }) => {
  return jsonRequest(`api/messenger/send-message`, {
    messageToId,
    isGroup,
    messageText,
  });
};

export const fetchClasses = () => {
  return jsonRequest(`api/messenger/classes-list`).then(processJsonResponse);
};

export const fetchSubjects = () => {
  return jsonRequest(`api/messenger/subjects-list`).then(processJsonResponse);
};

export const fetchDeps = () => {
  return jsonRequest(`api/messenger/deps-list`).then(processJsonResponse);
};

export const fetchConversationOpened = (oponentId, isgroup) => {
  return jsonRequest(`api/messenger/set-message-to-seen?oponentId=${oponentId}&isGroup=${isgroup}`);
};

export const fetchDeleteGroup = (id) => {
  return jsonRequest(`api/messenger/delete-group?id=${id}`);
};

export const fetchNewChatSearch = (prms) => {
  return jsonRequest(`api/messenger/persons-list`, prms).then(processJsonResponse);
};

export const createGroup = (prms) => {
  return jsonRequest(`api/messenger/create-group`, prms).then(processJsonResponse);
};

export const getCurrentUser = () => {
  return jsonRequest(`api/messenger/get-current-user`).then(processJsonResponse);
};

export const fetchGroupInfo = (id) => {
  return jsonRequest(`api/messenger/get-group-info?id=${id}`).then(processJsonResponse);
};

export const fetchPersonInfo = (id) => {
  return jsonRequest(`api/messenger/get-person-info?id=${id}`).then(processJsonResponse);
};

export const addGroupPerson = (id, groupId) => {
  return jsonRequest(`api/messenger/add-group-person?id=${id}&groupId=${groupId}`);
};

export const deleteGroupPerson = (id, groupId) => {
  return jsonRequest(`api/messenger/delete-group-person?id=${id}&groupId=${groupId}`);
};

export const fetchConversationFiles = (id, isGroup) => {
  return jsonRequest(`api/messenger/get-conversation-files?id=${id}&isGroup=${isGroup}`).then(processJsonResponse);
};

export const changeGroupName = (id, name) => {
  return jsonRequest(`api/messenger/change-group-name?id=${id}&name=${name}`);
};

export const fetchTestauthorize = (id, version) => {
  return jsonRequest(`api/test/authorize?id=${id}&version=${version}`).then(processJsonResponse);
};

// export const newMessage = () => {
//     return Promise.resolve(newMessage)
// }
